import React from 'react'
import { Card, CardHeader } from '@mui/material'
import { styled, Box } from '@mui/system'

const CardRoot = styled(Card)(() => ({
    height: '100%',
    padding: '20px 24px',
    width: '100%',
}))

const CardTitle = styled('div')(({ subtitle }) => ({
    fontSize: '1rem',
    fontWeight: '500',
    textTransform: 'capitalize',
    marginBottom: !subtitle && '16px',
}))

const SimpleCard = ({ children, title, subtitle, icon, action }) => {
    return (
        <CardRoot elevation={6}>
            <CardHeader action={action} title={title} subheader={subtitle} />
            {subtitle && <Box sx={{ mb: 2 }}>{subtitle}</Box>}
            {children}
        </CardRoot>
    )
}

export default SimpleCard
